module.exports = __webpack_public_path__ + "static/img/ctyiyuan4.621a6fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ctimaging/ctyiyuan4.png
// module id = xiCw
// module chunks = 5